document.addEventListener('DOMContentLoaded' , () =>{

    // mypage - account - member-modify-page
    if(document.querySelector('.member-modify-page')){
        let checkList = document.querySelectorAll('.social-area--check ul li');

        checkList.forEach( (el , index) =>{
            el.querySelector('.first__btn').addEventListener('click' , ()=>{
                el.querySelector('.hidden-box').classList.toggle('on');
                el.querySelector('.hidden-box--deep').classList.remove('on');
            })
            el.querySelector('.last__btn').addEventListener('click' , ()=>{
                el.querySelector('.hidden-box--deep').classList.toggle('on');
            })
        })
    }

    // mypage - account - withdrawal
    if(document.querySelector('.withdrawal-page')){
        
    }
});
